export default __webpack_public_path__ + "static/media/client11.6070acbf.jpeg";